<template>
    <header v-if="$route.name !== 'Plano'" class="cf">
        <div class="headerDiv">
            <!-- <headerSandbox></headerSandbox> -->
            <headerAdmin
                v-if="
                    // hasAccessUpdate('campaign_manager') ||
                    //     hasAccessCreate('product_manager') ||
                    //     hasAccessCreate('user_manager') ||
                    hasAccessBothAdmin()
                "
            ></headerAdmin>
            <menuHeader></menuHeader> <searchHeader ref="search" v-if="$route.name !== 'Plano'"></searchHeader>
            <ForecastBanner />
        </div>
        <countDown></countDown>
    </header>
</template>

<script>
import MenuHeader from "./MenuHeader.vue";
import SearchHeader from "./SearchHeader.vue";
import HeaderAdmin from "./HeaderAdmin.vue";
import HeaderPlano from "./HeaderPlano.vue";
import MenuHeaderPlano from "./MenuHeaderPlano.vue";
import HeaderSandBox from "./HeaderSandBox.vue";
import CountDown from "../admin/countdown/CountDown";
import ForecastBanner from "@/components/forecasts/elements/ForecastBanner";

export default {
    components: {
        menuHeader: MenuHeader,
        searchHeader: SearchHeader,
        headerPlano: HeaderPlano,
        menuHeaderPlano: MenuHeaderPlano,
        headerAdmin: HeaderAdmin,
        headerSandbox: HeaderSandBox,
        countDown: CountDown,
        ForecastBanner
    },
    data: () => ({
        menuHeader: false
    })
};
</script>
<style lang="scss" scoped>
header {
    .headerDiv {
        position: fixed;
        width: 100%;
        top: 0;
        z-index: 10;
    }
}
</style>



// WEBPACK FOOTER //
// Header.vue?d51bd31c